import { Group, Modal, Stack, Text } from '@mantine/core';
import { useIsMutating } from '@tanstack/react-query';
import { CancelButton } from 'components/CancelButton';
import { CreateButton } from 'components/CreateButton';
import { DeleteButton } from 'components/DeleteButton';
import { LoadingSuccessIndicator } from 'components/LoadingSuccessIndicator';
import { PageTitle } from 'components/PageTitle';
import { tKeys, useTranslation } from 'locales/index';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { isNonNullish, isNullish } from 'remeda';

import { useDeleteAutomation } from '../../api';
import { useEditAutomation } from '../AutomationWizard/controller';

import { AutomationsTable } from './AutomationsTable/AutomationsTable';

export const AutomationsIndex = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const [automationToDelete, setAutomationToDelete] = useState<string | null>(null);

  const { deleteAutomation } = useDeleteAutomation();
  const handleEditAutomation = useEditAutomation();

  const isUpdateAutomationOrderLoading =
    useIsMutating({ mutationKey: ['updateAutomationOrder'] }) >= 1;

  const confirmDeleteAutomation = () => {
    if (isNullish(automationToDelete)) return;
    deleteAutomation({ id: automationToDelete }, { onSuccess: () => setAutomationToDelete(null) });
  };

  return (
    <>
      <Stack h="100%" gap={0}>
        <PageTitle overrideTitle={t(tKeys.AUTOMATION.INDEX.TITLE)}>
          <Group>
            {t(tKeys.AUTOMATION.INDEX.TITLE)}
            <LoadingSuccessIndicator
              isLoading={isUpdateAutomationOrderLoading}
              inhibitLoadingState
            />
          </Group>
          <PageTitle.Subtitle>{t(tKeys.AUTOMATION.INDEX.SUBTITLE)}</PageTitle.Subtitle>
          <PageTitle.Actions>
            <CreateButton
              onClick={() => history.push('/settings/automations/new')}
              label={t(tKeys.AUTOMATION.NEW)}
            />
          </PageTitle.Actions>
        </PageTitle>
        <AutomationsTable
          handleDeleteAutomation={setAutomationToDelete}
          handleEditAutomation={handleEditAutomation}
        />
      </Stack>
      <Modal
        closeButtonProps={{
          tabIndex: -1,
        }}
        opened={isNonNullish(automationToDelete)}
        onClose={() => setAutomationToDelete(null)}
        title={t(tKeys.ATTENTION)}
      >
        <Text pb="lg">{t(tKeys.AUTOMATION.INDEX.DELETE_CONFIRMATION)}</Text>
        <Group mt="md" justify="end">
          <CancelButton onClick={() => setAutomationToDelete(null)} />
          <DeleteButton onClick={confirmDeleteAutomation} />
        </Group>
      </Modal>
    </>
  );
};
